import { render } from "./QuestionItem.vue?vue&type=template&id=80da5984&scoped=true"
import script from "./QuestionItem.vue?vue&type=script&lang=js"
export * from "./QuestionItem.vue?vue&type=script&lang=js"

import "./QuestionItem.vue?vue&type=style&index=0&id=80da5984&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-80da5984"

export default script